import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import module from 'app/modules/well-schematic-diagram/well-schematic-diagram.module';
import { WellSchematicApplicationService } from '../../services/well-schematic-application.service';
import { WellSchematicSearchStateService } from '../../state/well-schematic-search.state';

@Component({
  selector: 'app-wbs-dashboard',
  standalone: true,
  imports: module,
  templateUrl: './dashboard.page.html',
  styleUrl: './dashboard.page.scss'
})

export class WbsDashboard {
  searchForm: UntypedFormGroup;

  wellSchematics: any[] = []

  constructor(
    private router: Router,
    private service: WellSchematicApplicationService,
    private _formBuilder: UntypedFormBuilder,
    private readonly state: WellSchematicSearchStateService) {
  }

  ngOnInit() {
    this.setSearch()
    this.getWellSchematicList()

    const saved = this.state.get();
    if (saved) {
      this.searchForm.patchValue(saved);
      this.state.clear();
    }

  }

  viewDashboard(wellSchematic: any) {
    if (this.searchForm.dirty) this.state.set(this.searchForm.value);

    this.router.navigate(
      [`/well-schematic-diagram-dashboard/${wellSchematic.wellStringId}/details/${wellSchematic.wellSchematicId}`],
    );
  }

  handleSearch(event$) {
    const field = event$?.Field;
    const platform = event$?.Platform;
    const well = event$?.Well;
    const string = event$?.String;

    if ([field, platform, well, string].some(v => v != null && v !== '')) {
      this.getWellSchematicList()
    }
  }

  setSearch() {
    // this.sortInfo = 'Field'
    this.searchForm = this._formBuilder.group({
      Page: [1],
      PageSize: [20],
      totalPages: [1],
      OrderBy1: [null],
      OrderBy2: [null],
      OrderBy3: [null],
      OrderDir: 'asc',
      WellName: [''],
      PlatformName: [''],
      StringName: [''],
      FieldName: [''],
    });

    this.searchForm.get('Page').valueChanges.subscribe(value => this.getWellSchematicList());
    this.searchForm.get('PageSize').valueChanges.subscribe(value => this.getWellSchematicList());
  }

  getWellSchematicList() {
    const params = this.searchForm.getRawValue();

    let search: any = {
      wellLongName: params.Well?.wellLongName,
      stringShortName: params.String?.stringShortName,
      platformLongName: params.Platform?.platformLongName,
      fieldLongName: params.Field?.fieldLongName,
    };

    const saved = this.state.get();

    if (saved) {
      search = {
        wellLongName: saved.Well?.wellLongName,
        stringShortName: saved.String?.stringShortName,
        platformLongName: saved.Platform?.platformLongName,
        fieldLongName: saved.Field?.fieldLongName,
      };
    }

    this.service.getWellSchematicDashboard({ ...params, search }).subscribe((res) => {
      this.wellSchematics = res.data.data ?? []
      this.searchForm.patchValue({ totalPages: res.data?.totalPages ?? 1 })

      let totalPages = res.data?.totalRecords / res.data?.size
      if (totalPages >= 1) {
        totalPages = Math.ceil(totalPages)
        this.searchForm.patchValue({ totalPages: totalPages })
      }

      this.wellSchematics.forEach((item, index) => {
        this.service.getAttachmentImageUrl(item.id).subscribe(
          (blobVal) => {
            // Assign the blob value to the object
            this.wellSchematics[index] = {
              ...item,
              wellSchematicBlob: blobVal
            };
          },
        );
      });
    })
  }

  reset() {
    this.state.clear();
    this.setSearch();
    this.getWellSchematicList();
  }

  nextPage() {
    let nextPage = this.searchForm.get('Page')?.value + 1
    this.searchForm.patchValue({ Page: nextPage })
  }

  previousPage() {
    let previousPage = this.searchForm.get('Page')?.value - 1
    this.searchForm.patchValue({ Page: previousPage })
  }
}
